/* eslint react/no-danger: 'off' */
/* global globals, translations */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

const FAQ = (props) => {
  const html = get(globals, 'faq', '');
  if (!html.length) {
    return (null);
  }

  const { intro } = props;

  return (
    <div className="block block--text ptf pbs tal">
      {intro.length > 0 && (
        <div className="mtl tsi">
          {get(translations, intro, intro)}
        </div>
      )}
      <div className="mbm">
        <div
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </div>
    </div>
  );
};

FAQ.propTypes = {
  intro: PropTypes.string,
};

FAQ.defaultProps = {
  intro: 'txt: Ja radusies kāda problēma vai jautājums, varbūt interesējošo vari atrast pie biežāk uzdotajiem jautājumiem',
};

export default FAQ;
